
// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import html2pdf from 'html2pdf.js';
// import cisceLogo from '../../img/mdu_logo.png';
// import controllerSign from '../../img/sign.png';

// const ResultPage = () => {
//   const API_BASE_URL = 'http://127.0.0.1:5001/api/mdu'; // same as before
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [indexNo, setIndexNo] = useState(null);
//   const [studentData, setStudentData] = useState(null);
//   const [loading,   setLoading] = useState(true);
//   const [error,     setError] = useState(null);

//   useEffect(() => {
//     let currentId = null;

//     // 1) NEW: support query param ?indexNo=...  // <<< NEW
//     const searchParams = new URLSearchParams(location.search || '');
//     const queryIndexNo = searchParams.get('indexNo');

//     if (queryIndexNo) {
//       currentId = queryIndexNo;
//       console.log('ResultPage: IndexNo found in URL query:', currentId);
//     }
//     // 2) Fallback: location.state (old behaviour)
//     else if (location.state && location.state.indexNo) {
//       currentId = location.state.indexNo;
//       console.log('ResultPage: IndexNo found in location.state:', currentId);
//     }
//     // 3) Fallback: localStorage (old behaviour)
//     else {
//       currentId = localStorage.getItem('resultIndexNo');
//       if (currentId) {
//         console.log('ResultPage: IndexNo found in localStorage:', currentId);
//         localStorage.removeItem('resultIndexNo');
//       } else {
//         console.log('ResultPage: No indexNo found in URL, state or localStorage.');
//       }
//     }

//     setIndexNo(currentId);

//     if (!currentId) {
//       setError('No result found! Please check your Course/UID/Index number and try again.');
//       setLoading(false);
//       return;
//     }

//     const fetchStudent = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await fetch(`${API_BASE_URL}/public/students/${currentId}`, {
//           method: 'GET',
//           headers: { 'Content-Type': 'application/json' },
//         });

//         if (!response.ok) {
//           const errorData = await response.json().catch(() => ({}));
//           if (response.status === 404) {
//             throw new Error('Result not found for this Index Number.');
//           }
//           throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json();
//         setStudentData(data);
//       } catch (err) {
//         console.error('Error fetching student for Result Page:', err);
//         setError(err.message || 'Failed to load student data.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStudent();
//   }, [location.search, location.state, API_BASE_URL]); // <<< CHANGED: include location.search

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       const date = new Date(dateString);
//       const day = String(date.getDate()).padStart(2, '0');
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch {
//       return 'Invalid Date';
//     }
//   };

//   const formatIndexNo = (indexNoString) => {
//     const displayIndexNo = indexNoString || indexNo;
//     if (!displayIndexNo || String(displayIndexNo).length !== 10) return displayIndexNo;
//     const part1 = String(displayIndexNo).substring(0, 7);
//     const part2 = String(displayIndexNo).substring(7, 10);
//     return `${part1} / ${part2}`;
//   };

//   const formatBottomTimestamp = (date) => {
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();

//     let hours = date.getHours();
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const ampm = hours >= 12 ? 'PM' : 'AM';
//     hours = hours % 12;
//     hours = hours ? hours : 12;

//     return `${day}/${month}/${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
//   };

//   const downloadPdf = () => {
//     const element = document.getElementById('result-content');

//     if (element && studentData) {
//       const originalOverflow = document.body.style.overflow;
//       document.body.style.overflow = 'hidden';

//       const opt = {
//         margin: 0,
//         filename: `Result_${studentData.candidateName.replace(/\s/g, '_')}_${studentData.indexNo}.pdf`,
//         image: { type: 'jpeg', quality: 0.98 },
//         html2canvas: {
//           scale: 4,
//           logging: true,
//           dpi: 600,
//           letterRendering: true,
//           useCORS: true,
//           windowWidth: element.scrollWidth,
//           windowHeight: element.scrollHeight,
//           width: element.offsetWidth,
//         },
//         jsPDF: {
//           unit: 'mm',
//           format: [209.9, 297.1],
//           orientation: 'portrait',
//         },
//       };

//       html2pdf().set(opt).from(element).save().then(() => {
//         document.body.style.overflow = originalOverflow;
//       });
//     } else {
//       console.error('Could not find element with ID "result-content" for PDF conversion.');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen bg-gray-100">
//         <p className="text-xl text-blue-600">Loading student result...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100 p-4">
//         <p className="text-xl text-red-600 mb-4">Error: {error}</p>
//         <button
//           onClick={() => navigate('/dashboard')}
//           className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
//         >
//           Go to Dashboard
//         </button>
//       </div>
//     );
//   }

//   if (!studentData) {
//     return (
//       <div className="text-center py-10 text-gray-500 text-lg min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
//         <p className="mb-4">No student data found for the provided ID.</p>
//         <button
//           onClick={() => navigate('/dashboard')}
//           className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
//         >
//           Go to Dashboard
//         </button>
//       </div>
//     );
//   }

//   // same subjects + SUPW row
//   const allSubjectsForTable = [
//     ...(studentData.subjects || []),
//     { subjectName: 'SUPW & COMMUNITY SERVICE', marks: studentData.supwGrade, isSupw: true },
//   ].filter((s) => s.marks !== undefined && s.marks !== null);

//   return (
//     <div className="flex flex-col items-center min-h-screen font-sans text-gray-800 py-8 bg-gray-100">
//       {/* MAIN MARKSHEET – with watermark + MDU theme */}
//       <div
//         id="result-content"
//         className="bg-white mx-auto relative shadow-lg border-[6px] border-red-700 text-[13px] leading-relaxed"
//         style={{ width: '893px' }} // ~21cm
//       >
//         {/* INNER BORDER + WATERMARK CONTAINER */}
//         <div className="m-2 border-[2.5px] border-red-700 relative overflow-hidden">
//           {/* WATERMARK */}
//           <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.3]">
//             <img
//               src={cisceLogo}
//               alt="MDU Watermark"
//               className="w-1/4 max-w-md object-center"
//             />
//           </div>

//           {/* CONTENT OVER WATERMARK */}
//           <div className="relative">
//             {/* top band: logo + header + details */}
//             <div className="px-5 pt-4 pb-3 border-b border-red-700 bg-white/90">
//               <div className="flex items-center">
//                 {/* logo left */}
//                 <div
//                   className="w-24 h-20 flex-shrink-0 flex justify-center bg-center bg-contain bg-no-repeat pointer-events-none select-none"
//                   style={{ backgroundImage: `url(${cisceLogo})` }}
//                 ></div>

//                 {/* center heading */}
//                 <div className="flex-1 text-center leading-tight">
//                   <p className="text-[10px] uppercase tracking-wide">
//                     (Established under Haryana Act No. 25 of 1975)
//                   </p>
//                   <p className="text-2xl font-extrabold tracking-wide text-red-800 mt-1">
//                     MAHARSHI DAYANAND UNIVERSITY, ROHTAK
//                   </p>
//                   <p className="mt-1 text-sm font-semibold uppercase tracking-wide">
//                     RESULT-CUM-DETAILED MARKS CARD
//                   </p>
//                   <p className="mt-0.5 text-sm font-medium uppercase tracking-wide">
//                     BACHELOR OF COMMERCE
//                   </p>
//                   <p className="mt-0.5 text-[11px] font-medium uppercase tracking-wide">
//                     EXAM&nbsp;{studentData.resultYear || ''}
//                   </p>
//                 </div>

//                 {/* right small details box */}
//                 <div className="w-40 text-[11px] border border-red-700 rounded-sm px-2 py-1 leading-snug ml-3 bg-white/90">
//                   <div className="flex justify-between">
//                     <span className="font-semibold">DMC No.</span>
//                     <span>{studentData.id}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="font-semibold">Reg. No.</span>
//                     <span>{studentData.candidateId}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="font-semibold">Roll No.</span>
//                     <span>{studentData.indexNo}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* row: Course / Semester info */}
//             <div className="px-5 py-2 border-b border-red-700 text-[12px] bg-white/90">
//               <div className="flex justify-between">
//                 <div>
//                   <span className="font-semibold mr-1">Course:</span>
//                   <span>BACHELOR OF COMMERCE</span>
//                 </div>
//                 <div>
//                   <span className="font-semibold mr-1">Semester:</span>
//                   <span>—</span>
//                 </div>
//                 <div>
//                   <span className="font-semibold mr-1">Exam:</span>
//                   <span>{studentData.resultYear}</span>
//                 </div>
//               </div>
//             </div>

//             {/* candidate details block */}
//             <div className="px-5 py-3 border-b border-red-700 text-[12.5px] bg-red-50/70">
//               <div className="grid grid-cols-[120px_1fr] gap-y-1">
//                 <div className="font-semibold">Name:</div>
//                 <div className="font-bold">
//                   {studentData.candidateName?.toUpperCase() || 'N/A'}
//                 </div>

//                 <div className="font-semibold">Father&apos;s Name:</div>
//                 <div className="font-normal">
//                   {studentData.sonOf?.toUpperCase() || 'N/A'}
//                 </div>

//                 <div className="font-semibold">College / School:</div>
//                 <div className="font-normal">
//                   {studentData.school?.toUpperCase() || 'N/A'}
//                 </div>

//                 <div className="font-semibold">Date of Birth:</div>
//                 <div className="font-normal">
//                   {studentData.dob ? formatDate(studentData.dob) : 'N/A'}
//                 </div>

//                 <div className="font-semibold">Index No.:</div>
//                 <div className="font-normal">
//                   {formatIndexNo(studentData.indexNo) || 'N/A'}
//                 </div>
//               </div>
//             </div>

//             {/* DETAIL OF MARKS header */}
//             <div className="px-5 py-2 text-center border-b border-red-700 bg-red-100/90">
//               <span className="font-bold tracking-wide text-[13px]">
//                 DETAIL OF MARKS
//               </span>
//             </div>

//             {/* SUBJECT TABLE */}
//             <div className="px-5 pt-3 pb-1 bg-white/95">
//               <div className="border border-red-300">
//                 <table className="w-full text-[12.5px]">
//                   <thead>
//                     <tr className="bg-red-200 border-b border-red-300">
//                       <th className="py-1.5 px-2 w-[40px] border-r border-red-300 text-center font-bold">
//                         Sr. No.
//                       </th>
//                       <th className="py-1.5 px-2 border-r border-red-300 text-left font-bold">
//                         Subject
//                       </th>
//                       <th className="py-1.5 px-2 w-[120px] text-right font-bold">
//                         Percentage&nbsp;Marks
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {allSubjectsForTable.length > 0 ? (
//                       allSubjectsForTable.map((subject, index) => (
//                         <tr
//                           key={index}
//                           className={index % 2 === 0 ? 'bg-white' : 'bg-red-50'}
//                         >
//                           <td className="py-1.5 px-2 border-t border-red-200 text-center align-top">
//                             {index + 1}
//                           </td>
//                           <td className="py-1.5 px-2 border-t border-red-200 font-semibold align-top">
//                             {subject.subjectName?.toUpperCase()}
//                           </td>
//                           <td className="py-1.5 px-2 border-t border-red-200 text-right align-top">
//                             {subject.marks !== undefined ? subject.marks : 'N/A'}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td
//                           colSpan={3}
//                           className="p-4 text-center text-gray-500"
//                         >
//                           No subject data available.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* RESULT LINE + note */}
//             <div className="px-5 pt-3 pb-2 text-[12.5px] bg-white/95">
//               <div className="flex">
//                 <span className="font-semibold mr-2">Result:</span>
//                 <span className="font-bold">
//                   {studentData.result
//                     ? studentData.result.toUpperCase()
//                     : 'N/A'}
//                 </span>
//               </div>

//               {studentData.result?.toUpperCase() === 'PASS' && (
//                 <div className="mt-2 text-[12.5px]">
//                   <span className="font-semibold">
//                     Passed and has obtained&nbsp;
//                   </span>
//                   <span className="font-bold">
//                     {studentData.totalMarks || '________________'}
//                   </span>
//                   <span>&nbsp;marks.</span>
//                 </div>
//               )}
//             </div>

//             {/* SIGNATURES + place/date */}
//             <div className="px-5 pt-4 pb-3 text-[11.5px] border-t border-red-200 bg-white/95">
//               <div className="flex justify-between mb-6">
//                 <div>
//                   <div>
//                     <span className="font-semibold mr-1">Place:</span>
//                     <span>Rohtak</span>
//                   </div>
//                   <div>
//                     <span className="font-semibold mr-1">Date:</span>
//                     <span>{formatBottomTimestamp(new Date())}</span>
//                   </div>
//                 </div>

//                 <div className="flex gap-12 items-end">
//                   {/* controller of exams */}
//                   <div className="text-center">
//                     <div
//                       className="h-12 w-40 mx-auto bg-center bg-contain bg-no-repeat opacity-90"
//                       style={{ backgroundImage: `url(${controllerSign})` }}
//                     ></div>
//                     <div className="mt-1 text-[11px]">
//                       CONTROLLER OF EXAMINATIONS
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>{/* end relative content */}
//         </div>{/* end inner border */}
//       </div>

//       {/* PRINT BUTTON */}
//       <div className="mt-8">
//         <button
//           onClick={downloadPdf}
//           className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg shadow-md"
//         >
//           Print Result
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ResultPage;



import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import cisceLogo from '../../img/mdu_logo.png';
import controllerSign from '../../img/sign.png';

// const API_BASE_URL = 'http://127.0.0.1:5001/api/mdu';
const API_BASE_URL = 'https://peakybalvinder.pythonanywhere.com/api/mdu';

// ---------- small helpers ----------

const toNumber = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const formatBottomTimestamp = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;

  return `${day}/${month}/${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
};

// Reg. No. formatter: 19AU4433 → 19-AU-4433
const formatIndexNoNice = (indexNoString) => {
  if (!indexNoString) return 'N/A';
  const s = String(indexNoString).replace(/\s+/g, '');
  if (s.length <= 4) return s;
  const part1 = s.slice(0, 2);
  const part2 = s.slice(2, 4);
  const part3 = s.slice(4); // rest
  return `${part1}-${part2}-${part3}`;
};

// ---- NEW: convert number → words (international system) ----
const numberToWords = (num) => {
  if (num === 0) return 'ZERO';

  const belowTwenty = [
    '', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE',
    'TEN', 'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN',
    'SEVENTEEN', 'EIGHTEEN', 'NINETEEN',
  ];
  const tens = [
    '', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY',
    'NINETY',
  ];
  const scales = ['','THOUSAND','MILLION','BILLION'];

  const toWordsUnderThousand = (n) => {
    let str = '';
    if (n >= 100) {
      const h = Math.floor(n / 100);
      str += belowTwenty[h] + ' HUNDRED';
      n = n % 100;
      if (n > 0) str += ' ';
    }
    if (n >= 20) {
      const t = Math.floor(n / 10);
      str += tens[t];
      const r = n % 10;
      if (r > 0) str += ' ' + belowTwenty[r];
    } else if (n > 0) {
      str += belowTwenty[n];
    }
    return str;
  };

  let n = Math.floor(num);
  let scaleIndex = 0;
  let parts = [];

  while (n > 0 && scaleIndex < scales.length) {
    const chunk = n % 1000;
    if (chunk > 0) {
      let chunkWords = toWordsUnderThousand(chunk);
      if (scales[scaleIndex]) {
        chunkWords += ' ' + scales[scaleIndex];
      }
      parts.unshift(chunkWords);
    }
    n = Math.floor(n / 1000);
    scaleIndex++;
  }

  return parts.join(' ').trim();
};

const ResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [indexNo, setIndexNo] = useState(null);
  const [semester, setSemester] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ---------- fetch data ----------
  useEffect(() => {
    let currentId = null;
    let currentSem = null;

    const searchParams = new URLSearchParams(location.search || '');
    const queryIndexNo = searchParams.get('indexNo');
    const querySem = searchParams.get('semester');

    if (queryIndexNo) {
      currentId = queryIndexNo;
      currentSem = querySem || null;
      console.log('ResultPage: IndexNo from URL query:', currentId, 'Sem:', currentSem);
    } else if (location.state && location.state.indexNo) {
      currentId = location.state.indexNo;
      currentSem = location.state.semester || null;
      console.log('ResultPage: IndexNo from location.state:', currentId, 'Sem:', currentSem);
    } else {
      currentId = localStorage.getItem('resultIndexNo');
      currentSem = localStorage.getItem('resultSemester');
      if (currentId) {
        console.log('ResultPage: IndexNo from localStorage:', currentId, 'Sem:', currentSem);
        localStorage.removeItem('resultIndexNo');
        localStorage.removeItem('resultSemester');
      } else {
        console.log('ResultPage: No indexNo found in URL, state or localStorage.');
      }
    }

    setIndexNo(currentId);
    setSemester(currentSem);

    if (!currentId) {
      setError('No result found! Please check your Course/UID/Index number and try again.');
      setLoading(false);
      return;
    }

    const fetchStudent = async () => {
      setLoading(true);
      setError(null);
      try {
        let url;
        if (currentId && currentSem) {
          url = `${API_BASE_URL}/public/students?indexNo=${encodeURIComponent(
            currentId
          )}&semester=${encodeURIComponent(currentSem)}`;
        } else {
          url = `${API_BASE_URL}/public/students/${currentId}`;
        }

        const response = await fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          if (response.status === 404) {
            throw new Error('Result not found for this Index Number / semester.');
          }
          throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setStudentData(data);
      } catch (err) {
        console.error('Error fetching student for Result Page:', err);
        setError(err.message || 'Failed to load student data.');
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [location.search, location.state]);

  const downloadPdf = () => {
    const element = document.getElementById('result-content');

    if (element && studentData) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      const opt = {
        margin: 0,
        filename: `Result_${(studentData.candidateName || '')
          .replace(/\s/g, '_')}_${studentData.indexNo}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 4,
          logging: true,
          dpi: 600,
          letterRendering: true,
          useCORS: true,
          windowWidth: element.scrollWidth,
          windowHeight: element.scrollHeight,
          width: element.offsetWidth,
        },
        jsPDF: {
          unit: 'mm',
          format: [209.9, 297.1],
          orientation: 'portrait',
        },
      };

      html2pdf().set(opt).from(element).save().then(() => {
        document.body.style.overflow = originalOverflow;
      });
    } else {
      console.error('Could not find element with ID "result-content" for PDF conversion.');
    }
  };

  // ---------- loading / error ----------
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <p className="text-xl text-blue-600">Loading student result...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100 p-4">
        <p className="text-xl text-red-600 mb-4">Error: {error}</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  if (!studentData) {
    return (
      <div className="text-center py-10 text-gray-500 text-lg min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
        <p className="mb-4">No student data found for the provided ID.</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  // ---------- derived data from studentData ----------

  const courseName =
    studentData.course ||
    (studentData.classSelected
      ? String(studentData.classSelected).split(' - Sem ')[0]
      : '') ||
    '';

  const semLabel = studentData.semester || semester || '';

  const examMonth = studentData.examMonth || '';
  const examYear = studentData.resultYear || '';
  const examMonthShort = examMonth ? examMonth.slice(0, 3).toUpperCase() : '';
  const examLine =
    examMonthShort && examYear
      ? `Exam - ${examMonthShort} ${examYear}`
      : examYear
      ? `Exam - ${examYear}`
      : '';

  // parse parents from sonOf (mother on first line, father on second)
  let motherName = '';
  let fatherName = '';
  if (studentData.sonOf) {
    const parts = String(studentData.sonOf).split('\n');
    motherName = (parts[0] || '').trim();
    fatherName = (parts[1] || '').trim() || motherName;
  }

  // final semester flags & previous totals
  const isFinalSemester =
    studentData.isFinalSemester ?? studentData.is_final_semester ?? false;

  const previousYearTotalObtained =
    toNumber(studentData.previous_year_obtained_total) || 0;

  const previousYearMaxTotal =
    toNumber(studentData.previousYearMaxTotal ?? studentData.previousYearTotal) ||
    null;

  // normalise subjects
  const normalizedSubjects = (studentData.subjects || []).map((sub) => {
    const subjectName = sub.subjectName || sub.name || '';
    const subjectCode = sub.subjectCode || sub.code || '';

    const external =
      toNumber(sub.theory) ??
      toNumber(sub.externalMarks) ??
      null;

    const internal =
      toNumber(sub.practical) ??
      toNumber(sub.internalMarks) ??
      null;

    const minExternal =
      toNumber(sub.minExternalMarks) ??
      toNumber(sub.min_external_marks) ??
      null;

    const minInternal =
      toNumber(sub.minInternalMarks) ??
      toNumber(sub.min_internal_marks) ??
      null;

    const maxExternal =
      toNumber(sub.maxExternalMarks) ??
      toNumber(sub.max_external_marks) ??
      80;

    const maxInternal =
      toNumber(sub.maxInternalMarks) ??
      toNumber(sub.max_internal_marks) ??
      20;

    return {
      subjectName,
      subjectCode,
      external,
      internal,
      minExternal,
      minInternal,
      maxExternal,
      maxInternal,
    };
  });

  const rowsForTable = normalizedSubjects;

  // row-wise + grand totals
  let totalExternalObtained = 0;
  let totalInternalObtained = 0;
  let totalMaxExternal = 0;
  let totalMaxInternal = 0;

  const tableRows = rowsForTable.map((row, idx) => {
    const ext = toNumber(row.external);
    const int = toNumber(row.internal);
    const minExt = toNumber(row.minExternal);
    const minInt = toNumber(row.minInternal);
    const maxExt = toNumber(row.maxExternal);
    const maxInt = toNumber(row.maxInternal);

    const totalObtained =
      (ext != null ? ext : 0) + (int != null ? int : 0);
    const hasObtained = ext != null || int != null;
    const minTotal =
      (minExt != null ? minExt : 0) + (minInt != null ? minInt : 0);
    const hasMin = minExt != null || minInt != null;
    const maxTotal =
      (maxExt != null ? maxExt : 0) + (maxInt != null ? maxInt : 0);
    const hasMax = maxExt != null || maxInt != null;

    if (hasObtained) {
      totalExternalObtained += ext != null ? ext : 0;
      totalInternalObtained += int != null ? int : 0;
    }
    if (hasMax) {
      totalMaxExternal += maxExt != null ? maxExt : 0;
      totalMaxInternal += maxInt != null ? maxInt : 0;
    }

    return {
      index: idx,
      subjectLabel:
        row.subjectCode || row.subjectName
          ? `${row.subjectCode || ''}${
              row.subjectCode && row.subjectName ? '  ' : ''
            }${row.subjectName || ''}`
          : '',
      ext,
      int,
      totalObtained: hasObtained ? totalObtained : null,
      minExt,
      minTotal: hasMin ? minTotal : null,
      maxExt,
      maxInt,
      maxTotal: hasMax ? maxTotal : null,
    };
  });

  const grandObtainedCurrent = totalExternalObtained + totalInternalObtained;
  const grandMaxCurrent = totalMaxExternal + totalMaxInternal;

  // Special final-semester grand totals
  const grandObtainedAll = isFinalSemester
    ? grandObtainedCurrent + previousYearTotalObtained
    : grandObtainedCurrent;

  const grandMaxAll =
    isFinalSemester && previousYearMaxTotal != null
      ? grandMaxCurrent + previousYearMaxTotal
      : grandMaxCurrent;

  // ---------- RESULT LINE (NOW IN WORDS) ----------
  const numericForResult = isFinalSemester ? grandObtainedAll : grandObtainedCurrent;

  let resultLine;
  if (numericForResult && numericForResult > 0) {
    const words = numberToWords(numericForResult); // already UPPERCASE
    resultLine = `PASSED AND HAS OBTAINED ${words} MARKS`;
  } else {
    const resultUpper = (studentData.result || '').toUpperCase();
    resultLine = resultUpper || 'RESULT NOT DECLARED';
  }

  return (
    <div className="flex flex-col items-center min-h-screen font-sans text-gray-800 py-8 bg-gray-100">
      {/* MAIN MARKSHEET – with watermark + MDU theme */}
      <div
        id="result-content"
        className="bg-white mx-auto relative shadow-lg border-[6px] border-red-700 text-[13px] leading-relaxed"
        style={{ width: '893px' }} // ~21cm
      >
        {/* INNER BORDER + WATERMARK CONTAINER */}
        <div className="m-2 border-[2.5px] border-red-700 relative overflow-hidden">
          {/* WATERMARK */}
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.3]">
            <img
              src={cisceLogo}
              alt="MDU Watermark"
              className="w-1/4 max-w-md object-center"
            />
          </div>

          {/* CONTENT OVER WATERMARK */}
          <div className="relative">
            {/* top band: logo + header + details */}
            <div className="px-5 pt-4 pb-3 border-b border-red-700 bg-white/90">
              <div className="flex items-center">
                {/* logo left */}
                <div
                  className="w-24 h-20 flex-shrink-0 flex justify-center bg-center bg-contain bg-no-repeat pointer-events-none select-none"
                  style={{ backgroundImage: `url(${cisceLogo})` }}
                ></div>

                {/* center heading */}
                <div className="flex-1 text-center leading-tight">
                  <p className="text-[10px] uppercase tracking-wide">
                    (Established under Haryana Act No. 25 of 1975)
                  </p>
                  <p className="text-2xl font-extrabold tracking-wide text-red-800 mt-1">
                    MAHARSHI DAYANAND UNIVERSITY, ROHTAK
                  </p>
                  <p className="mt-1 text-sm font-semibold uppercase tracking-wide">
                    RESULT-CUM-DETAILED MARKS CARD
                  </p>
                  {/* Exam - MON YYYY */}
                  {examLine && (
                    <p className="mt-0.5 text-[11px] font-medium uppercase tracking-wide">
                      {examLine}
                    </p>
                  )}
                </div>

                {/* right small details box */}
                <div className="w-40 text-[11px] border border-red-700 rounded-sm px-2 py-1 leading-snug ml-3 bg-white/90">
                  <div className="flex justify-between">
                    <span className="font-semibold">DMC No.</span>
                    <span>{studentData.dmcNo || 'N/A'}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">Roll. No.</span>
                    <span>{(studentData.candidateId)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">Regn. No.</span>
                    <span>{formatIndexNoNice(studentData.indexNo)}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* row: Course / Semester info */}
            <div className="px-5 py-2 border-b border-red-700 text-[12px] bg-white/90">
              <div className="flex justify-between">
                <div>
                  <span className="font-semibold mr-1">Course:</span>
                  <span>{courseName ? courseName.toUpperCase() : 'N/A'}</span>
                </div>
                <div>
                  <span className="font-semibold mr-1">Semester:</span>
                  <span>{semLabel || 'N/A'}</span>
                </div>
              </div>
            </div>

            {/* candidate details block */}
            <div className="px-5 py-3 border-b border-red-700 text-[12.5px] bg-red-50/70">
              <div className="grid grid-cols-[140px_1fr] gap-y-1">
                <div className="font-semibold">Name:</div>
                <div className="font-bold">
                  {studentData.candidateName?.toUpperCase() || 'N/A'}
                </div>

                {/* Father first, then Mother; both bold */}
                <div className="font-semibold">Father&apos;s Name:</div>
                <div className="font-bold">
                  {fatherName ? fatherName.toUpperCase() : 'N/A'}
                </div>

                <div className="font-semibold">Mother&apos;s Name:</div>
                <div className="font-bold">
                  {motherName ? motherName.toUpperCase() : 'N/A'}
                </div>
              </div>
            </div>

            {/* DETAIL OF MARKS header */}
            <div className="px-5 py-2 text-center border-b border-red-700 bg-red-100/90">
              <span className="font-bold tracking-wide text-[13px]">
                DETAIL OF MARKS
              </span>
            </div>

            {/* SUBJECT TABLE */}
            <div className="px-5 pt-3 pb-1 bg-white/95">
              <div className="border border-red-300">
                <table className="w-full text-[12.5px]">
                  <thead>
                    {/* 5 columns */}
                    <tr className="bg-red-200 border-b border-red-300">
                      <th className="py-1.5 px-2 w-[40px] border-r border-red-300 text-center font-bold">
                        Sr. No.
                      </th>
                      <th className="py-1.5 px-2 border-r border-red-300 text-left font-bold">
                        Subject
                      </th>
                      <th className="py-1.5 px-2 border-r border-red-300 text-left font-bold">
                        Marks Obtained
                      </th>
                      <th className="py-1.5 px-2 border-r border-red-300 text-left font-bold">
                        Minimum Pass Marks
                      </th>
                      <th className="py-1.5 px-2 text-left font-bold">
                        Maximum Marks
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableRows.length === 0 && (
                      <tr>
                        <td
                          colSpan={5}
                          className="p-4 text-center text-gray-500"
                        >
                          No subject data available.
                        </td>
                      </tr>
                    )}

                    {/* main subject rows */}
                    {tableRows.map((row, idx) => (
                      <tr
                        key={idx}
                        className={idx % 2 === 0 ? 'bg-white' : 'bg-red-50'}
                      >
                        <td className="py-1.5 px-2 border-t border-red-200 text-center align-top font-semibold">
                          {idx + 1}
                        </td>
                        {/* Subject: code + double space + name */}
                        <td className="py-1.5 px-2 border-t border-red-200 font-semibold align-top">
                          {row.subjectLabel || '\u00A0'}
                        </td>

                        {/* Marks Obtained */}
                        <td className="py-1.5 px-2 border-t border-red-200 align-top">
                          <div className="grid grid-cols-[1.6fr_1fr] grid-rows-2 gap-x-1">
                            <div className="text-[11px]">
                              {row.ext != null ? row.ext : '\u00A0'}
                            </div>
                            <div className="row-span-2 flex items-end justify-end text-[12px]">
                              {row.totalObtained != null ? row.totalObtained : '\u00A0'}
                            </div>
                            <div className="text-[11px] mt-0.5">
                              {row.int != null ? row.int : '\u00A0'}
                            </div>
                          </div>
                        </td>

                        {/* Minimum Pass Marks */}
                        <td className="py-1.5 px-2 border-t border-red-200 align-top">
                          <div className="grid grid-cols-[1.6fr_1fr] grid-rows-2 gap-x-1">
                            <div className="text-[11px]">
                              {row.minExt != null ? row.minExt : '\u00A0'}
                            </div>
                            <div className="row-span-2 flex items-end justify-end text-[12px]">
                              {row.minTotal != null ? row.minTotal : '\u00A0'}
                            </div>
                            <div className="text-[11px] mt-0.5">
                              &nbsp;
                            </div>
                          </div>
                        </td>

                        {/* Maximum Marks */}
                        <td className="py-1.5 px-2 border-t border-red-200 align-top">
                          <div className="grid grid-cols-[1.6fr_1fr] grid-rows-2 gap-x-1">
                            <div className="text-[11px]">
                              {row.maxExt != null ? `${row.maxExt}T` : '\u00A0'}
                            </div>
                            <div className="row-span-2 flex items-end justify-end text-[12px]">
                              {row.maxTotal != null ? row.maxTotal : '\u00A0'}
                            </div>
                            <div className="text-[11px] mt-0.5">
                              {row.maxInt != null ? `${row.maxInt}S` : '\u00A0'}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}

                    {/* TOTAL / PREVIOUS / GRAND TOTAL block */}
                    {tableRows.length > 0 && !isFinalSemester && (
                      <tr className="bg-red-100 border-t border-red-300">
                        <td className="py-1.5 px-2 text-center font-semibold"></td>
                        <td className="py-1.5 px-2 font-semibold">TOTAL</td>
                        <td className="py-1.5 px-2 text-center">
                          {grandObtainedCurrent}
                        </td>
                        <td className="py-1.5 px-2">&nbsp;</td>
                        <td className="py-1.5 px-2 text-center">
                          {grandMaxCurrent}
                        </td>
                      </tr>
                    )}

                    {tableRows.length > 0 && isFinalSemester && (
                      <tr className="bg-red-100 border-t border-red-300">
                        <td className="py-1.5 px-2 text-center font-semibold"></td>
                        {/* one cell with 3 labels */}
                        <td className="py-1.5 px-2 align-top">
                          <div className="flex flex-col gap-0.5 text-[12px] font-semibold">
                            <span>Total</span>
                            <span>Previous total</span>
                            <span>Grand total</span>
                          </div>
                        </td>
                        {/* Marks Obtained column – 3 stacked totals */}
                        <td className="py-1.5 px-2 align-top">
                          <div className="flex flex-col items-center gap-0.5 text-[12px]">
                            <span>{grandObtainedCurrent}</span>
                            <span>{previousYearTotalObtained}</span>
                            <span>{grandObtainedAll}</span>
                          </div>
                        </td>
                        {/* Minimum Pass Marks col stays blank */}
                        <td className="py-1.5 px-2">&nbsp;</td>
                        {/* Maximum Marks column – 3 stacked totals */}
                        <td className="py-1.5 px-2 align-top">
                          <div className="flex flex-col items-center gap-0.5 text-[12px]">
                            <span>{grandMaxCurrent}</span>
                            <span>
                              {previousYearMaxTotal != null ? previousYearMaxTotal : 'N/A'}
                            </span>
                            <span>{grandMaxAll}</span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* RESULT LINE */}
            <div className="px-5 pt-3 pb-2 text-[12.5px] bg-white/95">
              <div className="flex">
                <span className="font-semibold mr-2">Result:</span>
                <span className="font-bold">
                  {resultLine}
                </span>
              </div>
            </div>

            {/* SIGNATURES + place/date */}
            <div className="px-5 pt-4 pb-3 text-[11.5px] border-t border-red-200 bg-white/95">
              <div className="flex justify-between mb-6">
                <div>
                  <div>
                    <span className="font-semibold mr-1">Place:</span>
                    <span>Rohtak</span>
                  </div>
                  <div>
                    <span className="font-semibold mr-1">Date:</span>
                    <span>{formatBottomTimestamp(new Date())}</span>
                  </div>
                </div>

                <div className="flex gap-12 items-end">
                  <div className="text-center">
                    <div
                      className="h-12 w-40 mx-auto bg-center bg-contain bg-no-repeat opacity-90"
                      style={{ backgroundImage: `url(${controllerSign})` }}
                    ></div>
                    <div className="mt-1 text-[11px]">
                      CONTROLLER OF EXAMINATIONS
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-[10px] text-gray-700 leading-snug space-y-1.5 px-5 mt-2 pb-4 bg-white/90">
            <p className="font-bold">Disclaimer</p>
            <p className="text-left">
              All information on this print is provided free of cost for personal perusal only, 
              and as such, is made available "AS IS". Every effort has been made to ensure accuracy of 
              the data on this print. However, MDU does not make any claim about the accuracy or validity of the 
              content on this print, or its suitability for any specific purpose whatsoever, whether express or implied. 
              MDU will not be responsible for any errors or omissions on this Web print. 
              In particular but without being limited thereto, MDU disclaims any responsibility 
              for typographical errors and other inaccuracies that may be contained within the print.
               Those users who access information on this Print have done so voluntarily of their own accord,
                any outcome (decision or claim) of such access is understood to be their sole sole responsibility. 
                MDU reserves the right to make changes to this information and print without notice.
            </p>
          </div>
          </div>{/* end relative content */}
        </div>{/* end inner border */}
      </div>

      {/* PRINT BUTTON */}
      <div className="mt-8">
        <button
          onClick={downloadPdf}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg shadow-md"
        >
          Print Result
        </button>
      </div>
    </div>
  );
};

export default ResultPage;